angular.module('unica_material.material_services')

.factory('MaterialListService', function ($http, getBaseApiURL) {

	var materialListService = {};

	materialListService.list = function (eventId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/material/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.materials;
			}

		});

	};

	materialListService.get = function (materialId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/material/detail/' + materialId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.material;
			}

		});

	};

	return materialListService;
});